export default __webpack_public_path__ + "static/media/handsonmobile.86bf3ba1.jpg";